import React from "react";
import "./navbar.css";

function Nav() {
  return (
    <div>

      <div className='navbar2'>

                <div className='container'>
                    <div className='red'></div>
                    <div className='yellow'></div>
                    <div className='green'></div>
                </div>

                <div className='welcomeText'>Deion Aujero – Portfolio</div>

                <div className=''></div>
                
            </div>
    </div>
  );
}

export default Nav;
